export default __webpack_public_path__ + "static/media/scenario.cb855b83.gif";